
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "version": "1.1",
    "xmlns": "http://www.w3.org/2000/svg",
    "xmlns:xlink": "http://www.w3.org/1999/xlink",
    "xmlns:a": "http://ns.adobe.com/AdobeSVGViewerExtensions/3.0/",
    "x": "0px",
    "y": "0px",
    "width": "141px",
    "height": "141px",
    "viewBox": "-0.5 -0.5 141 141",
    "enable-background": "new -0.5 -0.5 141 141",
    "xml:space": "preserve"
  },
  "children": [
    {
      "tag": "defs"
    },
    {
      "tag": "rect",
      "attrsMap": {
        "display": "none",
        "fill": "#F2F2F2",
        "width": "140",
        "height": "140"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "7.821",
        "y1": "32.233",
        "x2": "19.488",
        "y2": "32.233"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "13.654",
        "y1": "27.048",
        "x2": "13.654",
        "y2": "37.85"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M115.105,45.256v-4.856c0-2.763-2.238-5-5-5H63.475\r\n\tv-2.633c0-2.762-2.238-5-5-5H35.773c-2.763,0-5,2.238-5,5v2.633h-2.668c-2.761,0-5,2.237-5,5v4.856"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "119.635",
        "y1": "123.83",
        "x2": "127.701",
        "y2": "123.83"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "123.668",
        "y1": "120.245",
        "x2": "123.668",
        "y2": "127.714"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "18.105",
        "y1": "27.617",
        "x2": "26.173",
        "y2": "27.617"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "22.139",
        "y1": "24.031",
        "x2": "22.139",
        "y2": "31.501"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M61.206,118.2H28.105c-2.761,0-5-2.238-5-5\r\n\tl-5-62.943c0-2.762,2.239-5,5-5h92.668c2.76,0,5,2.238,5,5l-0.988,12.433"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M116.185,108.01l-0.394,5.19\r\n\tc0,2.762-2.143,5-4.785,5h-28.29"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M116.936,98.597\r\n\tc-3.111,2.482-7.055,3.967-11.344,3.967c-10.055,0-18.203-8.15-18.203-18.203c0-10.052,8.148-18.202,18.203-18.202\r\n\tc5.025,0,9.576,2.037,12.871,5.331"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M118.462,71.49\r\n\tc3.294,3.294,5.331,7.845,5.331,12.871c0,5.763-2.678,10.899-6.857,14.235"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M116.188,108.01c-3.234,1.452-6.82,2.26-10.597,2.26\r\n\tc-14.31,0-25.908-11.601-25.908-25.908c0-14.309,11.599-25.909,25.908-25.909S131.5,70.053,131.5,84.361\r\n\tC131.5,94.895,125.213,103.96,116.188,108.01"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "61.568",
        "y1": "118.2",
        "x2": "83.217",
        "y2": "96.553"
      }
    },
    {
      "tag": "path",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "d": "M82.075,118.2l-11.638,11.638\r\n\tc-2.83,2.83-7.422,2.83-10.252,0c-2.832-2.831-2.832-7.423,0-10.254l1.384-1.384"
      }
    },
    {
      "tag": "line",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "x1": "93.426",
        "y1": "106.851",
        "x2": "82.075",
        "y2": "118.2"
      }
    },
    {
      "tag": "polygon",
      "attrsMap": {
        "fill": "none",
        "stroke": "#B4B4B5",
        "stroke-width": "2",
        "stroke-miterlimit": "10",
        "points": "116.598,11.5 116.598,14.063 \r\n\t118.711,15.516 116.273,16.309 115.545,18.766 114.037,16.694 111.475,16.76 112.98,14.686 112.125,12.27 114.563,13.061 "
      }
    }
  ]
})
    }
  